import React from "react";

const LabelItem = ({ label, children }) => (
  <div className="label-item-container">
    <div className="label-item-label">{label}</div>
    <div className="label-item-content">{children}</div>
  </div>
);
export default LabelItem;
